<template>
  <b-container fluid>
    <div v-if="cantDownloadReason" class="d-flex">
      <div class="mr-2">
        <div class="alert-circle d-flex align-items-center justify-content-center">
          <span>!</span>
        </div>
      </div>
      <div class="px-2 d-flex align-items-center justify-content-center">
        <p class="message">{{ $t(`main.modalReason.${cantDownloadReason}.text`) }}</p>
      </div>
    </div>
    <b-row id="recommended-plans" :class="lifetimeLayout">
      <Plan
        v-for="(plan, i) in shownPlans"
        :key="i"
        v-model="annual"
        :plan-index="i"
        :plan="plan"
        :is-free-user="isFreeUser"
        :see-more-link="seeMoreLink"
        :lifetime="lifetime"
        :is-design-plan="isDesignPlan"
        :prismic-props="hasCustomPlans ? prismicProps : {}"
        :custom-plan="hasCustomPlans"
        @subscribe-click="subscribeClick"
      />
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Plan from '@/components/PurchaseFlow/Plans/Plan';
export default {
  components: {
    Plan
  },
  props: {
    singleLicensePlan: {
      type: Boolean,
      default: false
    },
    seeMoreLink: {
      type: String,
      required: false,
      default: ''
    },
    lifetime: {
      type: Boolean,
      default: false,
      required: false
    },
    cantDownloadReason: {
      type: String,
      required: false,
      default: ''
    },
    prismicProps: {
      type: Object,
      default: () => {}
    },
    customPlans: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  data() {
    return {
      annual: true
    };
  },
  computed: {
    ...mapGetters('plans', ['plansWithIndividual', 'plans', 'lifetimePlans']),
    ...mapState('vectors', ['actualVector']),
    isFreeUser() {
      return !this.$auth.loggedIn || this.$auth.user.idPlan === 1 ? true : false;
    },
    lifetimeLayout() {
      return this.lifetime ? 'justify-content-center plans-gap' : 'justify-content-around';
    },
    shownPlans() {
      if (this.hasCustomPlans) {
        return this.customPlans;
      }
      if (this.singleLicensePlan) {
        return this.plansWithIndividual;
      }
      if (this.lifetime) {
        return this.lifetimePlans;
      }
      return this.plans;
    },
    isDesignPlan() {
      return this.actualVector ? !!this.plansWithIndividual[0]?.extended : false;
    },
    hasCustomPlans() {
      return this.customPlans?.length > 0;
    }
  },
  async mounted() {
    if (!this.hasCustomPlans) {
      await this.$store.dispatch('plans/LOAD_PLANS');
    }
  },
  methods: {
    subscribeClick(plan) {
      this.$cookies.set('vx.plan', plan);
      this.$store.dispatch('plans/OPEN_PLAN', plan);
      this.$emit('suscribe-click', plan);
    }
  }
};
</script>
<style lang="scss">
.alert-circle {
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 200%;
  background-color: #ff4747;
}
.message {
  color: #4d4d4d;
  margin: 0;
  display: flex;
  align-items: center;
  text-align: center;
}
.plans-gap {
  gap: 26px;
}
</style>
